import { api } from '../client';

export interface ProxyRequest {
  path: string;
  method: string;
  headers?: Record<string, string>;
  body?: unknown;
  timeout?: number;
}

export interface ProxyCallRequest {
  client_id?: string;
  deployment_id?: string;
  endpoint: string;
  method: string;
  payload?: unknown;
  timeout?: number;
}

export interface ProxyResponse {
  success: boolean;
  status?: number;
  headers?: Record<string, string>;
  body?: unknown;
  error?: string;
  latency_ms?: number;
}

export interface ProxyBroadcastResponse {
  success: boolean;
  results: Array<{
    client_id: string;
    success: boolean;
    status?: number;
    body?: unknown;
    error?: string;
    latency_ms?: number;
  }>;
}

export interface ConnectivityTestResponse {
  success: boolean;
  connectivity: string;
  client_id: string;
  client_name?: string;
  api_port?: number;
  latency_ms?: number;
  error?: string;
}

export const proxyApi = {
  testClient: (clientId: string) =>
    api.get<ConnectivityTestResponse>(`/api/proxy/test/${clientId}`),

  forwardToClient: (clientId: string, data: ProxyRequest) =>
    api.post<ProxyResponse>(`/api/proxy/client/${clientId}`, data),

  broadcast: (data: ProxyRequest) =>
    api.post<ProxyBroadcastResponse>('/api/proxy/broadcast', data),

  call: (data: ProxyCallRequest) =>
    api.post<ProxyResponse>('/api/proxy/call', data),
};
